import React from 'react';
import PropTypes from 'prop-types';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import { StaticAudienceCampaignCreation } from '@bingads-webui-campaign-react/static-audience-campaign-creation';
// import { AudienceCampaignCreationWizard } from '@bingads-webui-campaign-legacy/audience-campaign/loader';
import { getEntityCreationStyle } from '../styles';
import { withCreationHeader, getCommonCampaignCreationViewOptions } from '../helper';

function CampaignCreationAudienceSimplified(props) {
  return (
    <div className={props.classes.CampaignCreationAudience}>
      <StaticAudienceCampaignCreation
        {...getCommonCampaignCreationViewOptions(props)}
      />
    </div>
  );
}

CampaignCreationAudienceSimplified.propTypes = {
  serverContext: PropTypes.shape({
    CurrentAccountInActive: PropTypes.bool.isRequired,
    Permissions: PropTypes.shape({
      IsReadOnlyUser: PropTypes.bool.isRequired,
      IsImpressionTrackingUrlsEnabled: PropTypes.bool.isRequired,
    }).isRequired,
    CurrentAccount: PropTypes.shape({
      CurrencyCode: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  perfMarker: perfMarkerPropTypes.isRequired,
  classes: PropTypes.shape({
    CampaignCreationAudience: PropTypes.string.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }),
};

CampaignCreationAudienceSimplified.defaultProps = {
  i18n: {
    getString: text => text,
  },
};

export const StyledCampaignCreationAudienceSimplified =
  withDefaultStyles(withCreationHeader(CampaignCreationAudienceSimplified), getEntityCreationStyle);
